import { formatUnixTimestamp } from '../../../../../shared/utils';

interface UserInfoCardProps {
    user?: {
        id?: string;
        nume?: string;
        email?: string;
        school?: {
            numeInstitutieInvatamant?: string;
        };
    };
    timestamp?: number | Date;
    points?: number | null;
    version?: number;
    participants?: number;
}

export function UserInfoCard({
    user,
    timestamp,
    points,
    version,
    participants,
}: UserInfoCardProps) {
    return (
        <div className="mb-6 p-4 bg-muted rounded-lg border border-border">
            <h3 className="font-semibold mb-3">Informații utilizator</h3>
            <div className="grid grid-cols-2 gap-3 text-sm">
                <div>
                    <span className="font-medium">Nume:</span>{' '}
                    {user?.nume || '-'}
                </div>
                <div>
                    <span className="font-medium">Email:</span>{' '}
                    {user?.email || '-'}
                </div>
                <div>
                    <span className="font-medium">Școală:</span>{' '}
                    {user?.school?.numeInstitutieInvatamant || '-'}
                </div>
                <div>
                    <span className="font-medium">Completat:</span>{' '}
                    {timestamp ? formatUnixTimestamp(timestamp) : '-'}
                </div>
                {points !== undefined && points !== null && (
                    <div>
                        <span className="font-medium">Puncte:</span>{' '}
                        <span className="text-primary font-semibold">
                            {points}
                        </span>
                    </div>
                )}
                {version !== undefined && (
                    <div>
                        <span className="font-medium">Încercare:</span>{' '}
                        #{version + 1}
                    </div>
                )}
                {participants !== undefined && (
                    <div>
                        <span className="font-medium">Participanți:</span>{' '}
                        <span className="text-primary font-semibold">
                            {participants}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
}
